import { Component, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { first, firstValueFrom } from 'rxjs';
import { Student } from 'src/app/models/student.model';
import { ConnectService } from 'src/app/services/connect.service';
import { ConfirmationDialogComponent } from 'src/app/shared/confirmation-dialog/confirmation-dialog.component';
import * as globals from '../../globals';
import { Status } from 'src/app/enums/status.model';
import { LoggingService } from '../../../services/logging.service';

@Component({
  standalone: false,
  selector: 'app-update-student',
  templateUrl: './update-student.component.html',
  styleUrls: ['./update-student.component.scss']
})
export class UpdateStudentComponent {

  constructor(
    private connectService: ConnectService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private logger: LoggingService) { }

  async updateEmailId() {
    this.loadingSpinner.emit(true);
    try {

      if(this.student.status === Status.Unassigned || this.student.status === Status.ErrorAssign) {
        this.displaySnackBar(globals.student_update_validation);
        this.loadingSpinner.emit(false);
        return;
      }
            
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          studentId: this.student?.id,
          dialogTitle: globals.student_update_title,
          description: `${globals.student_update}: FirstName - ${this.student?.first_name}, LastName - ${this.student?.last_name} and  Email-Id - ${this.student?.email_id}?`,
          cautionaryMessage: '',
          okButtonTitle: globals.update,
        },
        width: '500px'
      });

      const result = await firstValueFrom(dialogRef
        .afterClosed()
        .pipe(first()));

      if (result) {
        try {
          const data = {
            id: this.student.id,
            first_name: this.student.first_name,
            last_name: this.student.last_name,
            email_id: this.student.email_id
          };

          const updateStudentResponse = await firstValueFrom(this.connectService.updateStudent(data));
          this.logger.logEvent('Student Update Success', {studentId: this.student.id, email: this.student.email_id });
          this.displaySnackBar(updateStudentResponse ? globals.student_updated_successfully : globals.student_update_failed);
          this.saved.emit(true);
          this.loadingSpinner.emit(false);
        }
        catch (exception) {
          this.logger.logException(exception);
          this.displaySnackBar(globals.student_update_failed);
          this.loadingSpinner.emit(false);
        }
      }
      else {
        this.loadingSpinner.emit(false);
      }
    }
    catch {
    }
    return false;
  }  

  cancel = () => {
    this.submitting = false;
    this.cancelled.emit();
  };

  close = () => {
    this.submitting = false;
    this.cancelled.emit();
  };
  
  displaySnackBar = (message: string) => this.snackBar.open(message, null, {duration: 5000});

  submitting = false;

  @Input() student: Student = {};
  @Output() saved: EventEmitter<any> = new EventEmitter();
  @Output() cancelled: EventEmitter<any> = new EventEmitter();
  @Output() loadingSpinner: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('form', { static: true }) form: NgForm;

  @HostListener('window:beforeunload')
  canDeactivate = (): boolean => !this.form.dirty || this.form.submitted;
}
